import React, { useEffect, useRef } from "react";
import "./MdmCardMenu.css";
import RenderSvg from "../renderSvg/RenderSvg";
import Popper from "@mui/material/Popper";
import { DomainValue } from "../../services/mdmService/types";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

type MdmCard = {
  menuMoreOption: DomainValue | null;
  id: string | undefined;
  open: boolean;
  popoverAnchorElement: HTMLElement | null;
  mdmMenuRegistry: (
    event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => void;
};

function MdmCardMenu(props: MdmCard) {
  const { translate } = usePortalTranslation();
  const menuRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>, index: number) => {
    const items = itemRefs.current;
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        if (index < items.length - 1) {
          items[index + 1]?.focus();
        }
        break;
      case "ArrowUp":
        e.preventDefault();
        if (index > 0) {
          items[index - 1]?.focus();
        }
        break;
      case "Escape":
        props.popoverAnchorElement?.focus();
        break;
      case "Enter":
      case " ":
        e.preventDefault();
        props.mdmMenuRegistry(e);
        break;
    }
  };

  useEffect(() => {
    if (props.open && itemRefs.current.length > 0) {
      itemRefs.current[0]?.focus();
    }
  }, [props.open]);

  return (
    <Popper id="simple-popper" open={props.open} anchorEl={props.popoverAnchorElement} disablePortal>
      <div className="mdm-card-menu-more-options" ref={menuRef} role="menu">
        {props.menuMoreOption?.menuOption.map(({ id, icon, label }, index) => (
          <div
            className="mdm-card-menu-box"
            id={id}
            key={id}
            ref={(el) => (itemRefs.current[index] = el)}
            tabIndex={0}
            role="menuitem"
            onClick={props.mdmMenuRegistry}
            onKeyDown={(e) => handleKeyDown(e, index)}
          >
            <div className="mdm-card-menu-icon-name">
              <RenderSvg name={icon} />
            </div>
            <div className="mdm-card-menu-label">
              {translate(TranslationEnum.common_portal, label)}
            </div>
          </div>
        ))}
      </div>
    </Popper>
  );
}

export default MdmCardMenu;
